const Joi = require('joi')
const fields = require('./fields')

const loginSchema = Joi.object({
    nickOrEmail: Joi.alternatives().try(fields.emailField, fields.nicknameField).required().label('Nickname Or Email Address'),
    password: fields.loginPasswordField.required(),
    cAppAuthRequest: fields.objectIdField.optional().label('Creator App Auth Request'),
})

module.exports = loginSchema